import React from 'react';
import { TextField } from '@plug/ui';
import { useTranslation } from 'react-i18next';

const IntegrationFormNuvemShop = () => {
  const { t } = useTranslation();

  return (
    <>
      <TextField
        label={t(
          'hubly-dashboard.settings.admin.accordion.items.integration.body.form.nuvem-shop.code.label',
        )}
        name="code"
        placeholder={t(
          'hubly-dashboard.settings.admin.accordion.items.integration.body.form.nuvem-shop.code.placeholder',
        )}
        width="100%"
        disabled
      />
    </>
  );
};

export default IntegrationFormNuvemShop;
